import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useIdentityVerificationStatus() {
  const client = useApiClientUser()

  const identityReverifyMutation = useMutation({
    mutationFn: async () => {
      return await client.user.onboardingControllerReverifyIdentity({
        secure: true,
      })
    },
  })

  const identitySubmittedMutation = useMutation({
    mutationFn: async () => {
      return await client.user.onboardingControllerSetSubmittedIdentity({
        secure: true,
      })
    },
  })

  return {
    setIdentityReverifyStatus: identityReverifyMutation.mutateAsync,
    setIdentitySubmittedStatus: identitySubmittedMutation.mutateAsync,
  }
}

export { useIdentityVerificationStatus }
